<template>
  <div class="w-100 mt-3 mb-4 info-frete" id="info-frete">
    <div class="info-frete-item">
      <div class="info-frete-title">
        <i class="fa fa-clock-o"></i>
        <span>Validade</span>
      </div>
      <p>
        Cotação válida por <strong>24 horas</strong>, sujeita à disponibilidade de estoque.
      </p>
    </div>
    <div class="info-frete-item">
      <div class="info-frete-title">
        <i class="fa fa-truck"></i>
        <span>Frete</span>
      </div>
      <p>
        A Dicomp oferece frete gratuito para pedidos com valor em produtos acima de
        <strong>R$ 2.000,00</strong> (não inclusos impostos e premiações), exceto para racks,
        cabos, ferragens e painéis solares.
      </p>
    </div>
    <div class="info-frete-item">
      <div class="info-frete-title">
        <i class="fa fa-cube"></i>
        <span>Entrega</span>
      </div>
      <p>
        As entregas serão realizadas na <strong>modalidade padrão</strong>, sem serviço de carga
        e descarga.
      </p>
    </div>
    <div class="info-frete-item">
      <div class="info-frete-title">
        <i class="fa fa-map-marker"></i>
        <span>Condições especiais</span>
      </div>
      <p>
        Necessidades específicas, como agendamento, restrições de acesso, endereço alternativo ou
        entregas em locais de difícil acesso, deverão ser <strong>previamente informadas para análise.</strong>
      </p>
      <p>
        Eventuais custos adicionais decorrentes dessas condições serão de responsabilidade do destinatário.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrcamentoAvisos",
};
</script>

<style scoped>
.info-frete {
  background-color: #FAFBFE;
  border: 1px solid #628FE0;
  border-radius: 8px;
  color: #101828;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  line-height: 1.45;
  overflow: hidden;
}

.info-frete-item {
  padding: 14px 26px 16px;
  min-width: 0;
}

.info-frete-item + .info-frete-item {
  border-left: 1px solid #628FE0;
}

.info-frete-title {
  align-items: center;
  color: #0075EB;
  display: flex;
  font-size: 15px;
  font-weight: 700;
  gap: 14px;
  margin-bottom: 6px;
}

.info-frete-title i {
  font-size: 28px;
  line-height: 1;
  text-align: center;
  width: 32px;
}

.info-frete p {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 0;
  overflow-wrap: anywhere;
}

.info-frete p + p {
  margin-top: 6px;
}

.info-frete strong {
  color: #0075EB;
  font-weight: 700;
}

@media (max-width: 991.98px) {
  .info-frete {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .info-frete-item:nth-child(odd) {
    border-left: 0;
  }

  .info-frete-item:nth-child(n + 3) {
    border-top: 1px solid #628FE0;
  }
}

@media (max-width: 575.98px) {
  .info-frete {
    grid-template-columns: 1fr;
  }

  .info-frete-item,
  .info-frete-item:nth-child(odd) {
    border-left: 0;
  }

  .info-frete-item + .info-frete-item {
    border-left: 0;
    border-top: 1px solid #628FE0;
  }
}
</style>
